// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605181003/js/" + chunkId + "." + {"44":"03e160b2","225":"f46e547d","481":"e549c4be","486":"cf85309d","770":"28b470bf"}[chunkId] + ".0.7218519827052128.chunk.js";
};